import { html } from 'lit';
import { ChartPie } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-chart-pie')
export class PdsIconChartPie extends PdsIcon {
  @state()
  icon = ChartPie;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
